// extracted by mini-css-extract-plugin
export var redoItem = "_os-1";
export var redoTrigger = "_os-0";